export const LIVE_CHAT_STATUS_ONLINE = 'online';
export const LIVE_CHAT_STATUS_OFFLINE = 'offline';
export const LIVE_CHAT_STATUS_AWAY = 'away';
